export default function Booting() {
  return (
    <main className="screen">
      <div className="bar">
        <span className="logo">그래서요<span className="q">?</span></span>
      </div>
      <div className="center-screen" aria-live="polite" aria-busy="true">
        <div className="think" style={{ display: "flex", gap: 6 }}>
          <span /><span /><span />
        </div>
        <p className="note">준비하는 중이에요</p>
      </div>
    </main>
  );
}
